/**
 * Level Up Goodies — Theme JavaScript
 * Handles: Cart, Blend Selector, Capacity Tracker, Tabs, Gallery
 */

window.LUG = (function () {
  'use strict';

  const CONFIG = {
    weeklyCapacity: window.LUG_CONFIG ? window.LUG_CONFIG.weeklyCapacity : 220,
    deliveryPrice:  window.LUG_CONFIG ? window.LUG_CONFIG.deliveryPrice  : 10,
  };

  let blendCounts   = {};
  let qty           = 1;
  let deliveryMode  = 'pickup';
  let currentProduct = window.LUG_PRODUCT || null;

  const BLEND_NAMES = [
    'Vanilla Blend',
    'Plain Blend',
    'Fruit Crunch Blend',
    'Chocolate Coconut Fiber Blend',
  ];

  function blendTotal() {
    return Object.values(blendCounts).reduce((a, b) => a + b, 0);
  }

  function $(id) { return document.getElementById(id); }

  function showToast(msg) {
    const t = $('lug-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('show'), 2800);
  }

  // ── Cart Drawer ───────────────────────────────────────────────────────────
  function openCart() {
    $('cart-drawer')  && $('cart-drawer').classList.add('open');
    $('cart-overlay') && $('cart-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    $('cart-drawer')  && $('cart-drawer').classList.remove('open');
    $('cart-overlay') && $('cart-overlay').classList.remove('open');
    document.body.style.overflow = '';
  }

  function selectDelivery(mode, el) {
    deliveryMode = mode;
    document.querySelectorAll('.delivery-opt').forEach(o => o.classList.remove('active'));
    el.classList.add('active');

    const pickup   = $('pickup-reveal');
    const delivery = $('delivery-fields');
    const row      = $('delivery-row');

    if (mode === 'pickup') {
      pickup   && (pickup.style.display   = 'block');
      delivery && (delivery.style.display = 'none');
      row      && (row.style.display      = 'none');
    } else {
      pickup   && (pickup.style.display   = 'none');
      delivery && (delivery.style.display = 'block');
      row      && (row.style.display      = 'flex');
    }
    updateSummary();
  }

  function updateSummary() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      const sub   = cart.total_price;
      const extra = deliveryMode === 'delivery' ? CONFIG.deliveryPrice * 100 : 0;
      const total = sub + extra;
      const fmt   = function(v) { return '$' + (v / 100).toFixed(2); };
      const subtotalEl = document.getElementById('sum-subtotal');
      const totalEl    = document.getElementById('sum-total');
      const deliveryRow = document.getElementById('delivery-row');
      if (subtotalEl) subtotalEl.textContent = fmt(sub);
      if (totalEl)    totalEl.textContent    = fmt(total);
      if (deliveryRow) deliveryRow.style.display = deliveryMode === 'delivery' ? 'flex' : 'none';
    });
  }

  function getCartSubtotal() {
    const el = document.querySelector('[data-cart-total]');
    return el ? parseInt(el.dataset.cartTotal, 10) : 0;
  }

  // ── Blend Selector ────────────────────────────────────────────────────────
  function handleBlendClick(name) {
    if (!currentProduct) return;
    const p     = currentProduct;
    const total = blendTotal();
    const cnt   = blendCounts[name] || 0;

    if (p.allowRepeat) {
      if (total < p.choosable) {
        blendCounts[name] = cnt + 1;
      } else if (cnt > 0) {
        blendCounts[name] = cnt - 1;
        if (blendCounts[name] === 0) delete blendCounts[name];
      } else {
        showToast('Max ' + p.choosable + ' blends reached. Tap a selected blend to remove one.');
        return;
      }
    } else {
      if (cnt > 0) {
        delete blendCounts[name];
      } else if (total < p.choosable) {
        blendCounts[name] = 1;
      } else {
        showToast('You can only select ' + p.choosable + ' blends. Remove one first.');
        return;
      }
    }

    renderChips();
    renderSelectedTags();
    updateProgress();
    updateAddBtn();
  }

  function removeBlendTag(name) {
    if (!blendCounts[name]) return;
    blendCounts[name]--;
    if (blendCounts[name] === 0) delete blendCounts[name];
    renderChips();
    renderSelectedTags();
    updateProgress();
    updateAddBtn();
  }

  function renderChips() {
    const p         = currentProduct;
    const total     = blendTotal();
    const container = $('blend-chips');
    if (!container || !p) return;

    container.innerHTML = BLEND_NAMES.map(function (name) {
      const cnt        = blendCounts[name] || 0;
      const isSelected = cnt > 0;
      const isFull     = total >= p.choosable && cnt === 0;
      return '<button' +
        ' class="blend-chip' + (isSelected ? ' selected' : '') + (isFull ? ' chip-maxed' : '') + '"' +
        ' data-blend="' + name + '"' +
        ' onclick="LUG.handleBlendClick(\'' + name + '\')">' +
        name +
        '<span class="chip-count">' + cnt + '</span>' +
        '</button>';
    }).join('');
  }

function renderSelectedTags() {
  const container = $('selected-blends');
  if (!container) return;

  const entries = Object.entries(blendCounts).filter(e => e[1] > 0);

  if (entries.length === 0) {
    container.innerHTML = '<span class="none-selected">None selected yet</span>';
    return;
  }

  container.innerHTML = entries.flatMap(([name, cnt]) => {
    return Array.from({ length: cnt }).map(() => {
      return `
        <div class="selected-tag">
          <span class="tag-name">${name}</span>
          <button onclick="LUG.removeBlendTag('${name}')" aria-label="Remove ${name}">
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
              <path d="M7.76316 0.5L0.5 7.76316M0.5 0.5L7.76316 7.76316"
                stroke="#1E1E1E"
                stroke-linecap="round"
                stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      `;
    });
  }).join('');
}

  function updateProgress() {
    const p     = currentProduct;
    if (!p || !p.choosable) return;
    const total = blendTotal();
    const pct   = Math.round((total / p.choosable) * 100);
    const fill  = $('blend-prog-fill');
    const lbl   = $('blend-prog-label');
    if (fill) fill.style.width = pct + '%';
    if (lbl) {
      lbl.textContent = total + ' of ' + p.choosable + ' selected';
      lbl.className   = 'blend-progress-label' +
        (total === p.choosable ? ' done' : total > 0 ? ' going' : '');
    }
  }

  function updateAddBtn() {
    const btn = $('btn-add-cart');
    if (!btn || !currentProduct) return;
    const p     = currentProduct;
    const total = blendTotal();
    const done  = !p.choosable || total === p.choosable;

    if (!done) {
      const rem = p.choosable - total;
      btn.disabled    = true;
      btn.textContent = 'Select ' + rem + ' more blend' + (rem !== 1 ? 's' : '') + ' to continue';
      return;
    }
    btn.disabled    = false;
    btn.textContent = 'Add to cart';
  }

  function changeQty(delta) {
    qty = Math.max(1, qty + delta);
    const el = $('qty-display');
    if (el) el.textContent = qty;
    updateAddBtn();
  }

  function getSelectedBlendsList() {
    return Object.entries(blendCounts).flatMap(function (e) {
      return Array(e[1]).fill(e[0]);
    });
  }

  // ── Add to Cart ───────────────────────────────────────────────────────────
  function addToCart(btn) {
    if (!currentProduct) return;
    const p          = currentProduct;
    const variantId  = btn.dataset.variantId;
    const blendsList = getSelectedBlendsList();
    const properties = {};

    if (blendsList.length > 0) {
      properties['Blend Selection'] = blendsList.join(', ');
    }
    properties['Fulfillment'] = deliveryMode === 'delivery'
      ? 'Delivery (Calgary, Sunday)'
      : 'Pickup (Sunday)';

    btn.disabled    = true;
    btn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id:         parseInt(variantId, 10),
        quantity:   qty,
        properties: properties,
      }),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          showToast('Could not add to cart: ' + (data.description || 'Please try again.'));
          updateAddBtn();
          return;
        }
        // Reset state
        blendCounts = {};
        qty = 1;
        const qtyEl = $('qty-display');
        if (qtyEl) qtyEl.textContent = 1;
        renderChips();
        renderSelectedTags();
        updateProgress();
        updateAddBtn();
        updateCartCount();
        showToast('\u2705 ' + data.product_title + ' added to cart!');
        refreshCartDrawer();
        openCart();
      })
      .catch(function () {
        showToast('Something went wrong. Please try again.');
        updateAddBtn();
      });
  }

  // Quick add
  function quickAdd(handle, variantId, productType) {
    if (productType === 'pack') {
      window.location = '/products/' + handle;
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.status || data.status === 200) {
          updateCartCount();
          // ✅ Sirf toast — drawer nahi khulay ga
          showToast('\u2705 ' + (data.product_title || 'Item') + ' added to cart!');
          refreshCartDrawer();
          openCart();
        }
      });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const el = $('cart-count');
        if (el) el.textContent = cart.item_count;
      });
  }
  function refreshCartDrawer() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      // Update cart count
      const countEl = document.getElementById('cart-count');
      if (countEl) countEl.textContent = cart.item_count;

      const container = document.getElementById('cart-items-container');
      if (!container) return;

      if (cart.item_count === 0) {
        container.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
        const formSection = document.querySelector('.cart-form-section');
        if (formSection) formSection.style.display = 'none';
        return;
      }

      // Build items HTML
      let html = '';
      cart.items.forEach(function(item) {
        let propsHtml = '';
        if (item.properties) {
          Object.entries(item.properties).forEach(function([key, val]) {
            if (val && val !== '') {
              propsHtml += '<div class="cart-item-prop">' + key + ': ' + val + '</div>';
            }
          });
        }

        const imgHtml = item.image
          ? '<img src="' + item.image + '" alt="" width="60" height="60">'
          : '<span>' + item.title.charAt(0) + '</span>';

        html += '<div class="cart-item">' +
          '<div class="cart-item-img">' +
            imgHtml +
            (item.quantity > 1 ? '<span class="cart-item-qty-badge">' + item.quantity + '</span>' : '') +
          '</div>' +
          '<div class="cart-item-info">' +
            '<div class="cart-item-name">' + item.product_title + '</div>' +
            propsHtml +
            '<div class="cart-item-price">' + (item.final_line_price / 100).toFixed(2) + '</div>' +
            '<a href="/cart/change?id=' + item.key + '&quantity=0" class="cart-item-remove">Remove</a>' +
          '</div>' +
        '</div>';
      });

      container.innerHTML = html;

      // Subtotal calculate karo
      const subtotal = cart.total_price;
      const deliveryExtra = (typeof deliveryMode !== 'undefined' && deliveryMode === 'delivery')
        ? CONFIG.deliveryPrice * 100
        : 0;
      const total = subtotal + deliveryExtra;
      const fmt = function(v) { return '$' + (v / 100).toFixed(2); };

      // Form section handle karo
      let formSection = document.querySelector('.cart-form-section');
      if (!formSection) {
        const drawerInner = document.getElementById('cart-form-view');
        if (drawerInner) {
          drawerInner.insertAdjacentHTML('beforeend', `
            <div class="cart-form-section">
              <h3>Pickup or Delivery?</h3>
              <div class="delivery-toggle">
                <div class="delivery-opt active" onclick="LUG.selectDelivery('pickup',this)">
                  <h4>Pickup</h4><p>Every Sunday</p>
                  <span class="delivery-price-tag">FREE</span>
                </div>
                <div class="delivery-opt" onclick="LUG.selectDelivery('delivery',this)">
                  <h4>Delivery</h4><p>Every Sunday</p>
                  <span class="delivery-price-tag">+$10 </span>
                </div>
              </div>
              <div class="pickup-reveal" id="pickup-reveal">
                <strong>Pickup Location</strong>
                Shawarma and Falafel City<br>
                1245 Kensington Rd NW, Calgary, AB T2N 3P8<br>
                <span class="parking-note">Parking available behind the building</span>
              </div>
              <div class="delivery-fields" id="delivery-fields" style="display:none;">
                <label>Delivery Address (Calgary only)</label>
                <input type="text" id="delivery-address" placeholder="Street address">
              </div>
              <div class="order-summary">
                <div class="summary-row">
                  <span>Subtotal</span>
                  <span id="sum-subtotal">${fmt(subtotal)}</span>
                </div>
                <div class="summary-row" id="delivery-row" style="display:none;">
                  <span>Delivery</span><span>$10.00</span>
                </div>
                <div class="summary-row summary-total">
                  <span>Total</span>
                  <span id="sum-total">${fmt(total)}</span>
                </div>
              </div>
              <a href="/collections/all" class="btn-continue-shopping btn-place-order">Continue Shopping</a>
              <a href="/checkout" class="btn-place-order">Proceed to Checkout</a>
              <p class="checkout-note">Orders close Saturday 11 AM. Calgary only.</p>
            </div>`);
        }
      } else {
        formSection.style.display = '';
        // Subtotal update karo
        const subtotalEl = document.getElementById('sum-subtotal');
        const totalEl    = document.getElementById('sum-total');
        if (subtotalEl) subtotalEl.textContent = fmt(subtotal);
        if (totalEl)    totalEl.textContent    = fmt(total);
      }

    })
    .catch(function() {});
  }
  // ── Tab Filter ────────────────────────────────────────────────────────────
  function filterProducts(tab, btn) {
    document.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');

    const bSection = $('blends-section');
    const pSection = $('packs-section');

    if (tab === 'all') {
      bSection && (bSection.style.display = '');
      pSection && (pSection.style.display = '');
    } else if (tab === 'blend') {
      bSection && (bSection.style.display = '');
      pSection && (pSection.style.display = 'none');
    } else if (tab === 'pack') {
      bSection && (bSection.style.display = 'none');
      pSection && (pSection.style.display = '');
    }
  }

  // ── Gallery ───────────────────────────────────────────────────────────────
  function initGallery() {
    const thumbs = document.querySelectorAll('.thumb');
    const mainImg = document.querySelector('#main-img-el');
    const dots    = document.querySelectorAll('.gallery-dot');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const src = this.dataset.src;
        const idx = parseInt(this.dataset.index, 10);
        if (mainImg && src) mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        dots.forEach(function (d) { d.classList.remove('active'); });
        this.classList.add('active');
        if (dots[idx]) dots[idx].classList.add('active');
      });
    });
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    const cartToggle  = $('cart-toggle');
    const cartClose   = $('cart-close');
    const cartOverlay = $('cart-overlay');

    cartToggle  && cartToggle.addEventListener('click',  openCart);
    cartClose   && cartClose.addEventListener('click',   closeCart);
    cartOverlay && cartOverlay.addEventListener('click', closeCart);

    initGallery();

    if (window.LUG_PRODUCT) {
      currentProduct = window.LUG_PRODUCT;
      if (currentProduct.choosable > 0) {
        renderChips();
        renderSelectedTags();
        updateProgress();
      }
    }

    const mobileBtn = document.getElementById('mobile-menu-btn');
    const mobileNav = document.getElementById('mobile-nav');
    if (mobileBtn && mobileNav) {
      mobileBtn.addEventListener('click', function () {
        mobileNav.classList.toggle('open');
        mobileBtn.classList.toggle('active');
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  return {
    openCart:          openCart,
    closeCart:         closeCart,
    selectDelivery:    selectDelivery,
    handleBlendClick:  handleBlendClick,
    removeBlendTag:    removeBlendTag,
    changeQty:         changeQty,
    addToCart:         addToCart,
    quickAdd:          quickAdd,
    filterProducts:    filterProducts,
    showToast:         showToast,
    getSelectedCount:  blendTotal,
  };

})();